var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4712 21.4758L27.2631 19.6704C27.4947 19.1424 27.6105 18.8783 27.7724 18.7975C27.913 18.7273 28.0784 18.7273 28.219 18.7975C28.3809 18.8783 28.4967 19.1424 28.7283 19.6704L31.9006 26.9033M24.9467 24.9515L19.9816 36.272C19.725 36.857 19.5967 37.1495 19.6534 37.3288C19.7026 37.4842 19.8245 37.606 19.98 37.6549C20.1594 37.7114 20.4517 37.5828 21.0364 37.3256L27.6734 34.4053C27.7921 34.3531 27.8514 34.327 27.9131 34.3166C27.9677 34.3075 28.0235 34.3075 28.0781 34.3166C28.1397 34.327 28.1991 34.3531 28.3178 34.4053L34.9547 37.3256C35.5394 37.5828 35.8318 37.7114 36.0112 37.6549C36.1667 37.606 36.2886 37.4842 36.3377 37.3288C36.3944 37.1495 36.2661 36.857 36.0096 36.272L35.8054 35.8066M38 38L18 18",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon);
export default __webpack_public_path__ + "static/media/featureIcon.afc5b8ae4dcb1dc84713ca3c5b2112e9.svg";
export { ForwardRef as ReactComponent };